import './CompanyDetailsSection.css'
import React, { Component } from 'react'
import checkmate from 'checkmate'
import { Input } from 'components/base'
import Select from 'components/base/NativeSelect'
import CountriesList from 'countries-list'

function isEmail(str) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str)
}

function nonEmpty(str) {
  return str.length > 0
}

const FORM_FIELDS = {
  companyName: {
    required: true,
    label: 'Company Name',
    checkers: {
      nonEmpty,
    },
  },
  vatId: {
    label: 'VAT ID',
    checkers: {},
  },
  address: {
    required: true,
    label: 'Address',
    checkers: {
      nonEmpty,
    },
  },
  address2: {
    label: 'Address 2',
    checkers: {},
  },
  city: {
    required: true,
    label: 'City',
    checkers: {
      nonEmpty,
    },
  },
  zip: {
    required: true,
    label: 'ZIP or postal code',
    checkers: {
      nonEmpty,
    },
  },
  state: {
    label: 'State / province',
    checkers: {},
  },
  country: {
    required: true,
    label: 'Country',
    checkers: {
      nonEmpty,
    },
    type: 'select',
    optionsKey: 'countryOptions',
  },
  email: {
    required: true,
    label: 'Billing Email',
    checkers: {
      nonEmpty,
      isEmail,
    },
  },
}

const errorMessages = {
  nonEmpty: 'must be specified',
  isEmail: 'must be a valid email',
}

function errorsToMessage(errors) {
  return errors.map(error => errorMessages[error]).join(', ')
}

export const checker = checkmate(
  Object.keys(FORM_FIELDS).reduce(
    (checkers, fieldId) => ({
      ...checkers,
      [fieldId]: FORM_FIELDS[fieldId].checkers,
    }),
    {}
  )
)

export function getEmptyCompanyDetailsValues() {
  return Object.keys(FORM_FIELDS).reduce(
    (values, fieldId) => ({
      ...values,
      [fieldId]: '',
    }),
    {}
  )
}

export default class CompanyDetailsSection extends Component {
  state = {
    visitedInputs: {},
  }

  constructor(props) {
    super(props)
    const codeList = CountriesList.countries // {..., fr:'France', ...}

    this.countryOptions = Object.keys(codeList).reduce(
      (options, code) => {
        const data = codeList[code]
        return [...options, { value: code, title: data.name }]
      },
      [{ value: '', title: '---' }]
    )
  }

  render() {
    const errors = this.props.errors || {}
    return (
      <React.Fragment>
        <form
          id="company-details-section"
          onSubmit={event => {
            event.preventDefault()
            event.stopPropagation()
          }}
        >
          {[
            'companyName',
            'vatId',
            'address',
            'address2',
            'city',
            'zip',
            'state',
            'country',
            'email',
          ].map(id => {
            const field = FORM_FIELDS[id]
            const { label, required, type } = field
            const value = this.props.values[id]
            const inputErrors = errors[id]

            const visited = this.state.visitedInputs[id]
            const displayError = Boolean(inputErrors && visited)

            return (
              <div key={id} className="margin-vertical-normal">
                <label
                  htmlFor={id}
                  className="font-weight-bold font-size-large shade-05"
                >
                  {label}{' '}
                  {required ? (
                    <span
                      className="red position-relative"
                      style={{ bottom: 3 }}
                    >
                      *
                    </span>
                  ) : (
                    ''
                  )}
                  {displayError && (
                    <span className="red"> {errorsToMessage(inputErrors)}</span>
                  )}
                </label>
                {type === 'select' ? (
                  <Select
                    id={id}
                    error={displayError}
                    value={value}
                    onChange={this.onSelectChange}
                    onBlur={this.onInputBlur}
                    className="width-full"
                  >
                    {this[field.optionsKey].map(option => (
                      <option key={option.value} value={option.value}>
                        {option.title}
                      </option>
                    ))}
                  </Select>
                ) : (
                  <Input
                    id={id}
                    error={displayError}
                    value={value}
                    onChange={this.onInputChange}
                    onBlur={this.onInputBlur}
                  />
                )}
              </div>
            )
          })}
        </form>
        <div className="margin-top-normal font-size-smaller shade-20 margin-bottom-medium">
          <span className="red">*</span> indicates a required field
        </div>
      </React.Fragment>
    )
  }

  onInputChange = event => {
    const values = {
      ...this.props.values,
      [event.target.id]: event.target.value,
    }
    this.props.onChange(values)
  }

  onSelectChange = event => {
    // same as input changes but mark it as visited on change
    this.onInputChange(event)
    this.setState({
      visitedInputs: {
        ...this.state.visitedInputs,
        [event.target.id]: true,
      },
    })
  }

  onInputBlur = event => {
    this.setState({
      visitedInputs: {
        ...this.state.visitedInputs,
        [event.target.id]: true,
      },
    })
  }
}
